import styled from 'styled-components';

export const StyledParentPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;